import { Button, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { SupportForm } from '@/entities/SupportForm';

import { PlaceTakenFlow } from '@/features/PlaceTaken';

import useAppStore from '@/shared/store/app.store.ts';
import { BottomSheet } from '@/shared/uikit/components/bottomSheet';

import { IconBug, IconCar, IconPhone } from '@tabler/icons-react';

export const Support = () => {
	const isMobile = useAppStore((state) => state.isMobile);

	const [openedSupportForm, { close: closeSupportForm, open: openSupportForm }] =
		useDisclosure(false);
	const [openedPlaceTaken, { close: closePlaceTaken, open: openPlaceTaken }] = useDisclosure(false);

	return (
		<>
			<Stack>
				<Button
					leftSection={<IconBug />}
					variant="default"
					radius="lg"
					size="lg"
					fullWidth
					onClick={openSupportForm}
				>
					<Text fw={700} truncate>
						Сообщить о проблеме
					</Text>
				</Button>
				{isMobile && (
					<Button
						leftSection={<IconCar />}
						variant="default"
						radius="lg"
						size="lg"
						fullWidth
						onClick={openPlaceTaken}
					>
						<Text fw={700} truncate>
							Мое место занято
						</Text>
					</Button>
				)}
				{/*<Button*/}
				{/*	component="a"*/}
				{/*	href="mailto:support@pharmstd.ru"*/}
				{/*	variant="default"*/}
				{/*	radius="lg"*/}
				{/*	size="lg"*/}
				{/*>*/}
				{/*	<Group>*/}
				{/*		<IconMessage />*/}
				{/*		<Text size="md" fw={700}>*/}
				{/*			Обратиться в техподдержку*/}
				{/*		</Text>*/}
				{/*	</Group>*/}
				{/*</Button>*/}
				<Group justify="center" onClick={() => window.open('tel:+74953207009', '_self')}>
					<IconPhone opacity={0.5} />
					<Text c="dimmed">+7(495)320-70-09</Text>
				</Group>
			</Stack>

			<SupportForm opened={openedSupportForm} close={closeSupportForm} />

			{isMobile && <PlaceTakenFlow opened={openedPlaceTaken} close={closePlaceTaken} />}
		</>
	);
};
